import { normalizePhone, normalizeEmail } from './Helpers';

export const validatePerson = (person) => {
  const errors = {};
  const { firstName, lastName, mobile } = person;
  if (!firstName) {
    errors.firstName = "Imię jest wymagane.";
  }
  if (!lastName) {
    errors.lastName = "Nazwisko jest wymagane.";
  }
  if (!mobile) {
    errors.mobile = "Numer telefonu jest wymagany.";
  } else if (mobile.length < 6) {
    errors.mobile = "Numer telefonu jest za krótki.";
  } else if (!mobile.match(/[+]?[()0-9 -]+$/)) {
    errors.mobile = "Nieprawidłowy numer telefonu.";
  }

  return errors;
};

const check = (validate) => {
  if (typeof validate === "function") {
    return validate;
  }
  if (typeof validate === "object") {
    return (label, value) => validate.reduce((result, validation) => {
      if (result) return result;
      return validation(label, value);
    }, null);
  }
  throw new Error(`Validation for type ${typeof validate} is not supported`);
};

export const validateValues = (values, validationConfig) => {
  const errors = {};
  // eslint-disable-next-line array-callback-return
  Object.keys(validationConfig).map((field) => {
    const { label, validate } = validationConfig[field];
    const value = values[field];
    const errMsg = check(validate)(label, value);
    if (errMsg) {
      errors[field] = errMsg;
    }
  });
  return errors;
};

export const mandatory = (label, value) => {
  if (!value) {
    return `Pole ${label} jest wymagane.`;
  }
  return null;
};

export const email = (label, value) => {
  if (!value.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/)) {
    return "Nieprawidłowy adres email .";
  }
  return null;
};


export const checkForDuplicateClient = (client, allClients, excludeId = null) => {
  const duplicates = [];
  const firstName = (client.firstName || '').trim().toLowerCase();
  const lastName = (client.lastName || '').trim().toLowerCase();
  const phone = normalizePhone(client.mobile);
  const normalizedEmail = normalizeEmail(client.email);

  allClients.forEach((existing) => {
    // Skip deleted clients or the client being edited
    if (existing.deleted || (excludeId && existing.id === excludeId)) return;

    const existingFirstName = (existing.firstName || '').trim().toLowerCase();
    const existingLastName = (existing.lastName || '').trim().toLowerCase();
    const existingPhone = normalizePhone(existing.mobile);
    const existingEmail = normalizeEmail(existing.email);

    const matchReasons = [];

    // Check name match - both first and last name if both provided
    if (firstName && lastName &&
        existingFirstName === firstName &&
        existingLastName === lastName) {
      matchReasons.push('imię i nazwisko');
    }

    // Check phone match
    if (phone && phone === existingPhone) {
      matchReasons.push('telefon');
    }

    // Check email match
    if (normalizedEmail && normalizedEmail === existingEmail) {
      matchReasons.push('email');
    }

    if (matchReasons.length > 0) {
      duplicates.push({
        ...existing,
        matchReasons,
      });
    }
  });

  return duplicates;
};

export const checkForDuplicateStudent = (student, allStudents, excludeId = null) => {
  const duplicates = [];
  const firstName = (student.firstName || '').trim().toLowerCase();
  const { clientId } = student;

  allStudents.forEach((existing) => {
    // Skip deleted students or the student being edited
    if (existing.deleted || (excludeId && existing.id === excludeId)) return;

    // Only check within the same client
    if (existing.clientId !== clientId) return;

    const existingFirstName = (existing.firstName || '').trim().toLowerCase();

    if (firstName && existingFirstName === firstName) {
      duplicates.push({
        ...existing,
        matchReason: 'imię',
      });
    }
  });

  return duplicates;
};

/**
 * Normalizes match reasons from either string (legacy) or array (new) format.
 * @param {Object} duplicate - Duplicate client object
 * @returns {string[]} Array of match reason strings
 */
export const getMatchReasons = (duplicate) => {
  if (Array.isArray(duplicate.matchReasons)) {
    return duplicate.matchReasons;
  }
  if (typeof duplicate.matchReason === 'string') {
    return [duplicate.matchReason];
  }
  return [];
};
